import React from 'react';
import { Route } from 'react-router-dom';
import App from './components/app';
import SubscriptionPlans from './screens/subscriptionPlans';
import StripeMain from './screens/stripeMain';
import LandingPage from './screens/landingPage';
import HandleStripeResponse from './screens/handleStripeResponse';

export default (
  <App>
    <Route path="/" component={LandingPage} />
    <Route path="/plans" exact component={SubscriptionPlans} />
    <Route path="/pay" exact component={StripeMain} />
    <Route
      path="/checkout/:transactionId/:sessionID/:paymentID/:paymentStatus"
      exact
      component={HandleStripeResponse}
    />
  </App>
);
